import { isRouteErrorResponse, useRouteError } from "react-router";
import { ErrorState } from "@/components/ui/error-state";

/**
 * Last-resort boundary for errors thrown while rendering a route (or while
 * loading its lazy chunk — e.g. a stale tab after a deploy). Kept free of
 * i18n hooks on purpose: it must render even when the failure happened
 * before messages were available.
 */
export function RouteErrorBoundary() {
  const error = useRouteError();
  console.error(error);

  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : "This page failed to load. Reloading usually fixes it.";

  return (
    <div className="examora-container max-w-xl py-16">
      <ErrorState message={message} onRetry={() => window.location.reload()} />
    </div>
  );
}
